import React from 'react';
import type { PaymentTerminalView } from '../../../services/payment-terminals/payment-terminals.service';
import classes from '../terminals-page.module.scss';

type TerminalsTableProps = {
  terminals: PaymentTerminalView[];
  isLoadingTerminals: boolean;
  companyNameByTenantId: Map<string, string>;
  expandedTerminalId: number | null;
  onToggleExpanded: (terminalId: number) => void;
  onEditTerminal: (terminal: PaymentTerminalView) => void;
};

export const TerminalsTable: React.FC<TerminalsTableProps> = ({
  terminals,
  isLoadingTerminals,
  companyNameByTenantId,
  expandedTerminalId,
  onToggleExpanded,
  onEditTerminal,
}) => {
  return (
    <div className={classes.tableWrap}>
      <table className={classes.table}>
        <thead>
          <tr>
            <th>חברה</th>
            <th>שם</th>
            <th>מספר מסוף</th>
            <th>מטבע</th>
            <th>פינפדים</th>
            <th>סטטוס</th>
            <th>נוצר בתאריך</th>
            <th>פעולות</th>
          </tr>
        </thead>
        <tbody>
          {terminals.map((terminal) => {
            const isExpanded = expandedTerminalId === terminal.id;
            const activePinpads = terminal.pinpads.filter((pinpad) => pinpad.isActive).length;
            return (
              <tr
                key={terminal.id}
                className={isExpanded ? `${classes.row} ${classes.expanded}` : classes.row}
                onClick={() => onToggleExpanded(terminal.id)}
                data-testid={`terminals-row-${terminal.id}`}
              >
                <td data-label="חברה">
                  {companyNameByTenantId.get(terminal.tenantId) ?? terminal.tenantId}
                </td>
                <td data-label="שם">{terminal.name}</td>
                <td data-label="מספר מסוף">{terminal.terminalNumber}</td>
                <td data-label="מטבע">{terminal.currencyType}</td>
                <td data-label="פינפדים">{`${activePinpads}/${terminal.pinpads.length}`}</td>
                <td data-label="סטטוס">
                  <span className={terminal.isActive ? classes.statusActive : classes.statusInactive}>
                    {terminal.isActive ? 'פעיל' : 'מושבת'}
                  </span>
                </td>
                <td data-label="נוצר בתאריך">
                  {new Date(terminal.createdAt).toLocaleDateString('he-IL')}
                </td>
                <td data-label="פעולות">
                  <div className={classes.actionsCell}>
                    <button
                      type="button"
                      className={classes.editButton}
                      onClick={(event) => {
                        event.stopPropagation();
                        onEditTerminal(terminal);
                      }}
                      data-testid={`terminals-edit-${terminal.id}`}
                    >
                      ערוך
                    </button>
                  </div>
                </td>
              </tr>
            );
          })}
          {terminals.length === 0 && !isLoadingTerminals && (
            <tr>
              <td colSpan={8} className={classes.empty}>
                אין מסופים עדיין. לחץ "צור מסוף" כדי להוסיף את הראשון.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};
